import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';
import type { ArticleWithComponents } from '../reducers/types';

const { clientTopology } = renderModel.get();
const locale = renderModel.getLocale();

export const getArticleById = (id: string, httpClient: HttpClientFactory): Promise<ArticleWithComponents> => {
  return httpClient
    .getInstance()
    .get(`${clientTopology.articlesUrl}/${id}?locale=${locale}`)
    .then((response) => response.data)
    .catch((error) => {
      logger.error({
        message: `fail to fetch Article by Id: ${id}`,
        error,
      });
      throw error;
    });
};
